import { EntityConfig } from "../../..";


export const ExpedicoesConfig : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
    },
    {
        id: 'observacoes',
        label: 'Observações',
        type: 'text'
    },
    {
        id: 'quantidade',
        label: 'Quantidade',
        type: 'number',
    },
    {
        id: 'guia',
        label: 'Guia',
        type: 'text'
    }
    
]